import api from './api';
import {isAxiosError} from 'axios';

const API_BASE_URL = '/api/v1/workflows/bindings';

export interface WorkflowBinding {
    id?: number;
    workflowType: string;
    userId: number;
    apiConnectionId?: number | null;
    isActive?: number;
    createdAt?: string;
    updatedAt?: string;
}

class WorkflowBindingService {
    async getAll(): Promise<WorkflowBinding[]> {
        const response = await api.get(`${API_BASE_URL}`);
        return response.data.data;
    }

    async create(data: WorkflowBinding): Promise<WorkflowBinding> {
        try {
            const response = await api.post(API_BASE_URL, data);
            return response.data.data;
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.message || '创建失败');
            }
            throw error;
        }
    }

    async update(id: number, data: Partial<WorkflowBinding>): Promise<WorkflowBinding> {
        try {
            const response = await api.put(`${API_BASE_URL}/${id}`, data);
            return response.data.data;
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.message || '更新失败');
            }
            throw error;
        }
    }

    async delete(id: number): Promise<void> {
        try {
            await api.delete(`${API_BASE_URL}/${id}`);
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.message || '删除失败');
            }
            throw error;
        }
    }
}

export const workflowBindingService = new WorkflowBindingService();
